export default {
  cashBook: 0, // Báo cáo không có đối tượng
};
